import script from "./TipsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TipsDialog.vue?vue&type=script&setup=true&lang=js"

import "./TipsDialog.vue?vue&type=style&index=0&id=77404272&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77404272"]])

export default __exports__